const imp = () => import(/* webpackChunkName: "loadSprite_module"*/  "../sprite/loadSprite_module");
const loadMap: { [key: string]: () => Promise<any> } = {
  "Icon-Batch-SMS": imp,
  "Icon-Batch-attention": imp,
  "Icon-Batch-delete2": imp,
  "Icon-Batch-forwarding": imp,
  "Icon-Batch-marking": imp,
  "Icon-Batch-read": imp,
  "Icon-Batch-participation": imp,
  "Icon-Batch-release": imp,
  "Icon-Batch-reminder": imp,
  "Icon-Batch-return": imp,
  "Icon-Batch-sharing": imp,
  "Icon-Batch-submission": imp,
  "Icon-Batch-supervision": imp,
  "Icon-Batch-transfer": imp,
  "Icon-Batch-urging": imp,
  "Icon-Bulk-mail": imp,
  "Icon-Business-information": imp,
  "Icon-CC": imp,
  "Icon-Cancel-attention": imp,
  "Icon-Cancel-sharing": imp,
  "Icon-Cancellation-of-participation": imp,
  "Icon-Copy-template": imp,
  "Icon-Countersign": imp,
  "Icon-Customer-consolidation": imp,
  "Icon-External-developments": imp,
  "Icon-Keep-a-record": imp,
  "Icon-Look-up-the-list": imp,
  "Icon-Modification-log": imp,
  "Icon-QQ": imp,
  "Icon-Quick-sort-settings": imp,
  "Icon-SMS": imp,
  "Icon-WeChat": imp,
  "Icon-anniversaries-of-important-events": imp,
  "Icon-e10": imp,
  "Icon-entrust": imp,
  "Icon-flow-chart": imp,
  "Icon-jointly-sign": imp,
  "Icon-release": imp,
  "Icon-rename": imp,
  "Icon-Card-template": imp,
  "Icon-Category-view": imp,
  "Icon-Classification-template": imp,
  "Icon-Custom-columns": imp,
  "Icon-Enable": imp,
  "Icon-Histogram-switching": imp,
  "Icon-Line-chart-switching": imp,
  "Icon-List-view02": imp,
  "Icon-Mark-complete": imp,
  "Icon-My-label": imp,
  "Icon-Pie-chart-switching": imp,
  "Icon-Public-label": imp,
  "Icon-Save-as-picture": imp,
  "Icon-Serial-number": imp,
  "Icon-Subproject": imp,
  "Icon-Table-view": imp,
  "Icon-Team-template": imp,
  "Icon-delete02": imp,
  "Icon-export": imp,
  "Icon-preview": imp,
  "Icon-reduction": imp,
  "Icon-share02": imp,
  "Icon-sort03": imp,
  "Icon-suspend": imp,
  "Icon-view": imp,
  "Icon-screen": imp,
  "Icon-Loading": imp,
  "Icon-Close-password": imp,
  "Icon-Open-password": imp,
  "Icon-Open-password02": imp,
  "Icon-sort02": imp,
  "Icon-Enterprise-wechat": imp,
  "Icon-Align-center": imp,
  "Icon-Align-left": imp,
  "Icon-Align-right": imp,
  "Icon-File-expansion": imp,
  "Icon-more02": imp,
  "Icon-grouping": imp,
  "Icon-operation02": imp,
  "Icon--Instructions": imp,
  "Icon-Cannot-be-edited": imp,
  "Icon-Circulated": imp,
  "Icon-Comment-reply": imp,
  "Icon-Compulsory-withdrawal": imp,
  "Icon-Consultation": imp,
  "Icon-Force-archiving": imp,
  "Icon-Printing": imp,
  "Icon-Print-log": imp,
  "Icon-Return-node": imp,
  "Icon-Timeout-settings": imp,
  "Icon-Total-person-time": imp,
  "Icon-Transfer": imp,
  "Icon-Viewed": imp,
  "Icon-Advanced-search-selected": imp,
  "Icon-cancel": imp,
  "Icon-complete": imp,
  "Icon-Floating-window": imp,
  "Icon-Put-it-away02": imp,
  "Icon-open": imp,
  "Icon-sort05": imp,
  "Icon-sort04": imp,
  "Icon-Anchor-point": imp,
  "Icon-Back-to-top": imp,
  "Icon-Long-arrow": imp,
  "Icon-Drag-file": imp,
  "Icon-Batch-entrustment": imp,
  "Icon-department02": imp,
  "Icon-Shrink-list": imp,
  "Icon-Expand-list": imp,
  "Icon-enter": imp,
  "Icon-Branch": imp,
  "Icon-Common-Groups": imp,
  "Icon-Do-not-show-subordinates": imp,
  "Icon-Has-Account": imp,
  "Icon-Show-subordinates": imp,
  "Icon-Wechat-Moments": imp,
  "Icon-all": imp,
  "Icon-group03": imp,
  "Icon-headquarters": imp,
  "Icon-post": imp,
  "Icon-delete04": imp,
  "Icon-Form-design": imp,
  "Icon-department03": imp,
  "Icon-group04": imp,
  "Icon-Enterprise-wechat02": imp,
  "Icon-Batch-delete03": imp,
  "Icon-Batch-storage": imp,
  "Icon-Batch-unseal": imp,
  "Icon-No-account": imp,
  "Icon-Rule-base-and02": imp,
  "Icon-Rule-base-or02": imp,
  "Icon-Rule-base-deletion": imp,
  "Icon-Rule-library-split": imp,
  "Icon-approval": imp,
  "Icon-send-out": imp,
  "Icon-intervene": imp,
  "Icon-Rule-base-and": imp,
  "Icon-Rule-base-or": imp,
  "Icon-Display-disabled": imp,
  "Icon-No-display-disabled": imp,
  "Icon-Display-disabled02": imp,
  "Icon-Process-status": imp,
  "Icon-drainage": imp,
  "Icon-help02": imp,
  "Icon-personnel02": imp,
  "Icon-Collection": imp,
  "Icon-Collection02": imp,
  "Icon-solid": imp,
  "Icon-enterprise": imp,
  "Icon-Upload-file": imp,
  "Icon-Upload-file02": imp,
  "Icon-Attachment-editor": imp,
  "Icon-More-attachments": imp,
  "Icon-Department-move-in": imp,
  "Icon-complete02": imp,
  "Icon-autograph02": imp,
  "Icon-Mail-forwarding": imp,
  "Icon-Email-reply": imp,
  "Icon-all02": imp,
  "Icon-group05": imp,
  "Icon-Abnormal-attendance": imp,
  "Icon-Attendance-setting": imp,
  "Icon-Clock-out-in-the-field": imp,
  "Icon-Complaint-handling": imp,
  "Icon-Copy-link": imp,
  "Icon-Exception-list": imp,
  "Icon-Shift-setting": imp,
  "Icon-picture-error": imp,
  "Icon-post02": imp,
  "Icon-QR-code02": imp,
  "Icon-enlarge03": imp,
  "Icon-narrow03": imp,
  "Icon-administrators02": imp,
  "Icon-micro-blog": imp,
  "Icon-Baidu": imp,
  "Icon-Douban": imp,
  "Icon-Freeze-column": imp,
  "Icon-Header": imp,
  "Icon-QQ-Zone": imp,
  "Icon-Terminal-Download": imp,
  "Icon-e10-02": imp,
  "Icon-subscribe": imp,
  "Icon-Form-top": imp,
  "Icon-Batch-addition": imp,
  "Icon-Batch-delete": imp,
  "Icon-Batch-modification": imp,
  "Icon-delete": imp,
  "Icon-add-to": imp,
  "Icon-copy": imp,
  "Icon-go-out": imp,
  "Icon-Rule-base": imp,
  "Icon-Android-scan-code": imp,
  "Icon-IOS-scan": imp,
  "Icon-Mac-client": imp,
  "Icon-PC-client": imp,
  "Icon-Superior-level-by-level-approval": imp,
  "Icon-remove": imp,
  "Icon-footprint": imp,
  "Icon-holiday-and-vacations": imp,
  "Icon-Condition-selection": imp,
  "Icon-Post-task": imp,
  "Icon-Predecessors": imp,
  "Icon-Cycle-creation": imp,
  "Icon-Project": imp,
  "Icon-Start-date": imp,
  "Icon-Subtask": imp,
  "Icon-Task-type": imp,
  "Icon-upload03": imp,
  "Icon-Task-work": imp,
  "Icon-Tips": imp,
  "Icon-Import": imp,
  "Icon-odf02": imp,
  "Icon-pdf02": imp,
  "Icon-Display-disabled03": imp,
  "Icon-Sharer": imp,
  "Icon-Participants": imp,
  "Icon-Chart-no-data": imp,
  "Icon-Reply-forwarding": imp,
  "Icon-Required": imp,
  "Icon-location": imp,
  "Icon-Conference-screen": imp,
  "Icon-linitialization": imp,
  "Icon-Batch-generation-expense": imp,
  "Icon-Batch-inspection": imp,
  "Icon-Batch-reimbursement02": imp,
  "Icon-Batch-disable": imp,
  "Icon-Alphabetical-order": imp,
  "Icon-Node-recovery-station": imp,
  "Icon-Related-to-me": imp,
  "Icon-Unread-messages": imp,
  "Icon-grouping02": imp,
  "Icon-Alphabetic-sorting": imp,
  "Icon-anniversaries-of-important-events02": imp,
  "Icon-May-pass": imp,
  "Icon-file02": imp,
  "Icon-Show-part-time": imp,
  "Icon-Do-not-show-part-time-jobs": imp,
  "Icon-start": imp,
  "Icon-Have-an-account": imp,
  "Icon-Bifurcation-merge-point": imp,
  "Icon-Bifurcation-starting-point": imp,
  "Icon-Deactivate-headquarters": imp,
  "Icon-Deactivate-segment": imp,
  "Icon-Intelligent-prediction": imp,
  "Icon-handle": imp,
  "Icon-role": imp,
  "Icon-headquarters02": imp,
  "Icon-wait-for": imp,
  "Icon-Open-o": imp,
  "Icon-Batch-end": imp,
  "Icon-Cancel-topping": imp,
  "Icon-End": imp,
  "Icon-Mark-top": imp,
  "Icon-vote": imp,
  "Icon-Batch-open": imp,
  "new-function": imp,
  "Icon-Cancel-like": imp,
  "Icon-like01": imp,
  "Icon-new-function": imp,
  "Icon-Split-line": imp,
  "Icon-Clear-cache": imp,
  "Icon-Batch-recovery": imp,
  "Icon-Batch-join": imp,
  "Icon-edition": imp,
  "Icon-Exit-the-system": imp,
  "Icon-terminal": imp,
  "Icon-Conditionsetting": imp,
  "Icon-Circulation-and-withdrawal": imp,
  "Icon-No-score": imp,
  "Icon-quote02": imp,
  "Icon-Notification-off": imp,
  "Icon-Notification-on": imp,
  "Icon-start-o": imp,
  "Icon-Voice-to-text01": imp,
  "Icon-ID": imp,
  "Icon-Password-login": imp,
  "Icon-function": imp,
  "Icon-function-2": imp,
  "Icon-turn-off-segment-selection": imp,
  "Icon-overtime": imp,
  "Icon-need-to-be-dealt-with": imp,
  "Icon-New-approval": imp,
  "Icon-handle02": imp,
  "Icon-Deleted-segment": imp,
  "Icon-Headquarters-deleted": imp,
  "Icon-Messageread": imp,
  "Icon-vote2": imp,
  "Icon-Free-node": imp,
  "Icon-Automatic-processing": imp,
  "Icon-node": imp,
  "Icon-Approval-process-settings": imp,
  "Icon-perator-settings": imp,
  "Icon-Node-settings": imp,
  "Icon-Unauthorized": imp,
  "Icon-Sensitive-words": imp,
  "Icon-Monthly-report": imp,
  "Icon-Reverse-order": imp,
  "Icon-positive-sequence": imp,
  "Icon-Document-distribution": imp,
  "Icon-hide": imp,
  "Icon-iframe": imp,
  "Icon-Recommended-close": imp,
  "Icon-Recommended-open": imp,
  "Icon-Data-preparation": imp,
  "Icon-Document-return": imp,
  "Icon-SQL": imp,
  "Icon-Self-service-view": imp,
  "Icon-data-connection": imp,
  "Icon-db": imp,
  "Icon-etl": imp,
  "Icon-Intelligent-prediction-o": imp,
  "Icon-Self-service-view-o": imp,
  "Icon-etl-o": imp,
  "Icon-Filter-override": imp,
  "Icon-Filter-selection": imp,
  "Icon-Screen-o": imp,
  "Icon-Document-comparison": imp,
  "Icon-Required-symbol": imp,
  "Icon-Row-seat": imp,
  "Icon-Version-comparison": imp,
  "Icon-Batch-editing-o": imp,
  "Icon-Advanced-document-settings": imp,
  "Icon-Document-permissions": imp,
  "Icon-sign": imp,
  "Icon-Batch-download": imp,
  "Icon-Add-sequence": imp,
  "Icon-Column-to-row": imp,
  "Icon-Java-data-set": imp,
  "Icon-Row-to-column": imp,
  "Icon-choice": imp,
  "Icon-input": imp,
  "Icon-output": imp,
  "Icon-system-data-o": imp,
  "Icon-system-data": imp,
  "Icon-value": imp,
  "Icon-Encrypted-forwarding": imp,
  "Icon-confirm": imp,
  "Icon-Examine-and-approve": imp,
  "Icon-process": imp,
  "Icon-pdf_ofd-distinguish": imp,
  "Icon-Infantcarecosts": imp,
  "Icon-Receivingandsendingunit": imp,
  "Icon-Batchtopping": imp,
  "Icon-Cloud-disk-file": imp,
  "Icon-Cloud-disk-folder": imp,
  "Icon-Document-version": imp,
  "Icon-other03": imp,
  "Icon-social-security": imp,
  "Icon-Upload-file02-o": imp,
  "Icon-Batch-confirmation-returned": imp,
  "Icon-Batch-repayment": imp,
  "Icon-Filterdata": imp,
  "Icon-Batch-write-off": imp,
  "Icon-seal": imp,
  "Icon-Batch-export": imp,
  "Icon-Batch-reminder-repayment": imp,
  "Icon-All": imp,
  "Icon-Absenteeism": imp,
  "Icon-Batch-lock": imp,
  "Icon-Batch-unlock": imp,
  "Icon-Cloud-synchronization": imp,
  "Icon-Doublecolumn": imp,
  "Icon-Forced-move-in": imp,
  "Icon-Icon-Calendar-view": imp,
  "Icon-Reopen-Archive": imp,
  "Icon-Pagingtable": imp,
  "Icon-Reopen-void": imp,
  "Icon-Startdate": imp,
  "Icon-Upload-and-download": imp,
  "Icon-Urgency": imp,
  "Icon-classification": imp,
  "Icon-duedate": imp,
  "Icon-file-o": imp,
  "Icon-decompose": imp,
  "Icon-void": imp,
  "Icon-work-overtime": imp,
  "Icon-Receiving": imp,

  "Icon-Excel-export": imp,
  "Icon-Excel-template": imp,
  "Icon-Excel-import": imp,
  "Icon-WPS-template": imp,
  "Icon-New-schedule": imp,
  "Icon-html-template": imp,
  "Icon-word-template": imp,
  "Icon-upload-colour": imp,
  "Icon-Cancel-void": imp,
  "Icon-Line-feed": imp,
  "Icon-Off-the-shelf": imp,
  "Icon-visual-editing": imp,
  "Icon-Line-feed-o": imp,
  "Icon-New-window": imp,
  "Icon-Batch-import": imp,
  "Icon-Cancel-follow": imp,
  "Icon-edit-1": imp,
  "Icon-keyboard": imp,
  "Icon-end-message": imp,
  "Icon-reduction02": imp,
  "Icon-send-emails": imp,
  "Icon-Send-request": imp,
  "Icon-Male-card": imp,
  "Icon-Maximize-1": imp,
  "Icon-Official-document-model": imp,
  "Icon-Add-concern": imp,
  "Icon-Female-card": imp,
  "Icon-at-the-left": imp,
  "Icon-suspension": imp,
  "Icon-at-the-right": imp,
  "Icon-Card-settings": imp,
  "Icon-Female-head02": imp,
  "Icon-Attendance-track": imp,
  "Icon-Male-head": imp,
  "Icon-Off-color": imp,
  "Icon-Unhide": imp,
  "Icon-decompose-o": imp,
  "Icon-initialization": imp,
  "Icon-Initialization-settings": imp,
  "Icon-Batch-addition01": imp,
  "Icon-Switch-the-value-method": imp,
  "Icon-Icon-Switch-the-value-method": imp,
  "Icon-Synchronization-table": imp,
  "Icon-vote-o": imp,
  "Icon-birthday": imp,
  "Icon-gift": imp,
  "Icon-Put-away": imp,
  "Icon-open02": imp,
  "Icon-system-safety": imp,
  "Icon-system-safety-o": imp,
  "Icon-birthday2": imp,
  "Icon-epidemic-prevention": imp,
  "Icon-Multilingual02-o": imp,
  "Icon-@And-comments-o": imp,
  "Icon-@And-comments": imp,
  "Icon-Back-calculation": imp,
  "Icon-Batch-move": imp,
  "Icon-Data-preprocessing": imp,
  "Icon-Model-deployment": imp,
  "Icon-Model": imp,
  "Icon-My-comments-o": imp,
  "Icon-My-comments": imp,
  "Icon-New-approval02": imp,
  "Icon-data-source01": imp,
  "Icon-termination": imp,
  "Icon-Expense-type-view": imp,
  "Icon-Batch-write-off02": imp,
  "Icon-Classification01": imp,
  "Icon-Folder-permission-settings": imp,
  "Icon-Deactivate": imp,
  "Icon-Write-off": imp,
  "Icon-Classification-management": imp,
  "Icon-markdown": imp,
  "Icon-Crop": imp,
  "Icon-Equipment-integration": imp,
  "Icon-Equipment-integration-o": imp,
  "Icon-add_subtract_personnel_range": imp,
  "Icon-data_column_synchronization": imp,
  "Icon-upload_again": imp,
  "Icon-Add-essence": imp,
  "Icon-Associated-invoice": imp,
  "Icon-Batch-unsharing": imp,
  "Icon-Clear-default-connection": imp,
  "Icon-Associated-itinerary": imp,
  "Icon-Disband-group": imp,
  "Icon-No-essence-added": imp,
  "Icon-No-information-authentication": imp,
  "Icon-Set-default-connection": imp,

}
export default loadMap;